module.exports = __webpack_public_path__ + "static/favicon-e88b56730d8ef0a7644a585e907deed9.ico";